import { useEffect, useMemo, useState, useCallback } from 'react'

function useSelect(ids: string[]) {
	const [selected, setSelected] = useState(new Set<string>())
	const [slider, setSlider] = useState(0)

	// Refreshes may remove sold items, but must never reapply the last slider
	// position or clear a manually assembled cart.
	useEffect(() => {
		const available = new Set(ids)
		setSelected((previous) => {
			const next = new Set([...previous].filter((id) => available.has(id)))
			return next.size === previous.size ? previous : next
		})
	}, [ids])
	useEffect(() => setSlider(selected.size), [selected])

	const allSelected = useMemo(() => selected.size === ids.length && ids.length > 0, [selected, ids])
	const onSelect = useCallback((id: string) => {
		setSelected((previous) => {
			const next = new Set(previous)
			if (next.has(id)) next.delete(id)
			else next.add(id)
			return next
		})
	}, [])
	const onSelectAll = useCallback(
		() => setSelected(allSelected ? new Set() : new Set(ids)),
		[ids, allSelected]
	)
	const onSliderChange = useCallback(
		([value]: number[]) => {
			const count = Math.max(0, Math.min(ids.length, Math.floor(value || 0)))
			setSelected(new Set(ids.slice(0, count)))
		},
		[ids]
	)
	return {
		setSelected,
		setSlider,
		selected,
		onSelect,
		onSelectAll,
		onSliderChange,
		slider,
		allSelected
	}
}
export default useSelect
